import { Plus } from "lucide-react"
import { useNavigate } from "react-router-dom"

import { CondominiumManagement } from "@/components/dashboard/superadmin/CondominiumManagement"
import { Page, PageHeader } from "@/components/superadmin/kit"
import { SuperAdminLayout } from "@/components/superadmin/SuperAdminLayout"
import { Button } from "@/components/ui/button"

const CondominiumsPage = () => {
  const navigate = useNavigate()
  return (
    <SuperAdminLayout>
      <Page>
        <PageHeader
          title="Organizações"
          description="Condomínios e empresas que usam a plataforma. Clique numa linha para ver cadastro, usuários e licenças."
          actions={<Button className="h-9 gap-1.5" onClick={() => navigate("/superadmin/organizacoes?nova=1")}><Plus className="h-4 w-4" />Nova organização</Button>}
        />
        <CondominiumManagement />
      </Page>
    </SuperAdminLayout>
  )
}

export default CondominiumsPage
